import {
    breakpointsTailwind,
    useBreakpoints as useVueUseBreakpoints,
} from "@vueuse/core";
import { computed } from "vue";

export const useBreakpoints = () => {
    const breakpoints = useVueUseBreakpoints(breakpointsTailwind);

    const isMobile = computed(() => breakpoints.smaller("md").value);
    const isTablet = computed(() => breakpoints.between("md", "lg").value);
    const isLaptop = computed(() => breakpoints.between("lg", "xl").value);
    const isDesktop = computed(() => breakpoints.greater("xl").value);

    return {
        ...breakpoints,
        isMobile,
        isTablet,
        isLaptop,
        isDesktop,
    };
};
